import destructSeconds, { DestructSeconds } from '~/utils/destruct-seconds'

export default function useDestructSeconds(s: number): DestructSeconds {
  return destructSeconds(s)
}
